<template>
    <v-main>
        <div id="core-view">
            <router-view v-slot="{ Component }">
                <v-fade-transition mode="out-in">
                    <component :is="Component" />
                </v-fade-transition>
            </router-view>
        </div>
        <!-- <core-footer v-if="$route.name !== 'Maps'" /> -->
        <core-footer v-if="$route.name !== 'Maps'" />
        <v-alert v-if="errorList.length > 0" class="errorMessages" color="error">
            <v-layout row align-bottom style="margin-bottom: 10px;">
                <div class="subheading" style="align-self: flex-end;">Errors have occurred</div>
                <v-spacer></v-spacer>
                <v-btn style="margin: 0px;" icon @click="errorMessageClear()"><v-icon color="white">cancel</v-icon></v-btn>
            </v-layout>
            <div class="" style="margin-left: 5px;">
                <div v-for="error in errorList" v-bind:key="error.id" class="error-item">
                    <div v-if="error.message">{{ error.status }} - {{ error.message }}</div>
                    <div v-if="error.url" class="error-url">{{ error.url }}</div>
                </div>
            </div>
        </v-alert>
    </v-main>
</template>

<script>
import { mapState } from 'vuex'
import coreFooter from '@/components/core/Footer'

export default {
    components: {
        coreFooter
    },
    metaInfo () {
        return {
            title: 'Spills & Complaints'
        }
    },
    computed: {
        ...mapState('app', {
            httpRun: store => store.httpRunning,
            errorList: 'httpErrorList'
        })
    },
    methods: {
        errorMessageClear () {
            this.$store.commit('app/clearErrors')
        }
    }
}
</script>

<style scoped>
    #core-view {
        padding-bottom: 100px;
    }
    .errorMessages {
        position: fixed;
        top: 0;
        right: 0;
        width: 300px;
        border: 2px solid;
        z-index: 9999;
        margin-top: 10px;
        margin-right: 10px;
    }
</style>
